import { HTTPError, TimeoutError } from '@fingermarkglobal/request';
import ky from 'ky';

const loyaltyPossibleRedemptions = async ({
  token,
  transactionId,
  payload,
  promoId,
}: {
  token: string;
  transactionId: string;
  payload: any;
  promoId: string;
}) => {
  console.info('fm-api - loyaltyPossibleRedemptions - started');
  try {
    if (!process.env.POI_APP_LOYALTY_SERVICE_ENDPOINT) {
      throw new Error(
        'fm-api - loyaltyPossibleRedemptions - failed to get loyalty logout endpoint in the environment file with the key POI_APP_LOYALTY_SERVICE_ENDPOINT.',
      );
    }

    const endpoint = `${process.env.POI_APP_LOYALTY_SERVICE_ENDPOINT}/loyalty/integration/${transactionId}/redemptions/${promoId}/possible`;

    const response = await ky.post(endpoint, {
      timeout: 30 * 1000,
      headers: { 'x-authorization-loyalty': `Bearer ${token}` },
      json: { cart: payload.cart },
    });

    if (!response.ok) {
      throw new Error('fm-api - loyaltyPossibleRedemptions - request failed. No response received');
    }

    console.info('fm-api - loyaltyPossibleRedemptions - finished', response);

    const data = await response.json();
    return data;
  } catch (err) {
    if (err instanceof HTTPError || err instanceof TimeoutError) throw err;

    console.error('fm-api - loyaltyPossibleRedemptions - error:', err);
    throw err;
  }
};

export { loyaltyPossibleRedemptions };
